import Vue from 'vue'

export const step = {
  namespaced: true,
  state: {
    prev: null,
    current: null,
    next: null,
    lists: null,
    items: null,
    showNameplate: null,
    selectItem: null,
  },
  mutations: {
    stepSet(state, payload) {
      if (payload.current) {
        let val = payload.current
        val.order = val.order
        Vue.set(state, 'current', val)
        Vue.set(state, 'current', val)
      }

      if (payload.prev) {
        let val = payload.prev
        val.order = val.order
        Vue.set(state, 'prev', val)
      }

      if (payload.next) {
        let val = payload.next
        val.order = val.order
        Vue.set(state, 'next', val)
      }

      Vue.set(state, 'showNameplate', payload.showNameplate)
    },
    selectItemSet(state, payload) {
      Vue.set(state, 'selectItem', payload)
    },
    listSet(state, payload) {
      Vue.set(state, 'lists', payload)
    },
    listSelectSet(state, payload) {
      for (let i=0; i<state.lists.length; i++) {
        if (state.lists[i].id === payload.id) {
          if (state.lists[i].refine) {
            Vue.set(state.lists[i], 'refine', null)
          } else {
            Vue.set(state.lists[i], 'refine', true)
          }
        }
      }
    },
    itemSet(state, payload) {
      Vue.set(state, 'items', payload)
    },
  },
}
